// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-photoprintdesktoperroroverlay_default__115y6","button":"idt-photoprintdesktoperroroverlay_button__ylkst","remove":"idt-photoprintdesktoperroroverlay_remove__3vqxg"};